var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkBeneficiaryArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40039 13.5996C2.40039 13.1578 2.75856 12.7996 3.20039 12.7996H12.8004C13.2422 12.7996 13.6004 13.1578 13.6004 13.5996C13.6004 14.0414 13.2422 14.3996 12.8004 14.3996H3.20039C2.75856 14.3996 2.40039 14.0414 2.40039 13.5996ZM5.03471 5.36529C4.72229 5.05288 4.72229 4.54634 5.03471 4.23392L7.43471 1.83392C7.58473 1.6839 7.78822 1.59961 8.00039 1.59961C8.21256 1.59961 8.41605 1.6839 8.56608 1.83392L10.9661 4.23392C11.2785 4.54634 11.2785 5.05288 10.9661 5.36529C10.6537 5.67771 10.1471 5.67771 9.83471 5.36529L8.80039 4.33098V10.3996C8.80039 10.8414 8.44222 11.1996 8.00039 11.1996C7.55856 11.1996 7.20039 10.8414 7.20039 10.3996L7.20039 4.33098L6.16608 5.36529C5.85366 5.67771 5.34713 5.67771 5.03471 5.36529Z",
    fill: "#00535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkBeneficiaryArrow);
export default __webpack_public_path__ + "static/media/bulk-beneficiary-arrow.f8b22493.svg";
export { ForwardRef as ReactComponent };